const originTitle = document.title;
let timer;

const setOriginTitle = () => {
  document.title = originTitle;
}

const resetTitle = () => {
  if (timer) {
    clearInterval(timer);
    timer = null;
  }
  setOriginTitle();
}

const updateTitle = (title) => {
  document.title = title;
}

const blinkTitle = (title, period = 800) => {
  let count = 0;
  if (timer) clearInterval(timer);
  timer = setInterval(() => {
    count++;
    if (count % 2) updateTitle(title);
    else setOriginTitle();
  }, period);
}

export { resetTitle, updateTitle, blinkTitle };